module.exports = __webpack_public_path__ + "img/image00013.5accfd8a.jpeg";